// src/utils/downloadFile.js
export function downloadTextFile(content, fileName = 'report.html', mime = 'text/html;charset=utf-8') {
  const blob = new Blob([content], { type: mime });
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = fileName;
  document.body.appendChild(a);
  a.click();
  a.remove();
  // آزادسازی
  setTimeout(() => URL.revokeObjectURL(url), 1000);
}
